var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import Certificate from "../Certificate";
import { isCertificateExpiringSoon, isCertificateSelected, } from "../../../../../helpers/certificatesUtils";
import CertificateCardContainer from "./subcomponents";
import useRewards from "../../../../../hooks/useRewards";
import { numericBreaks } from "../../../const/customBreakPoints";
var VirtualizedListRow = function (_a) {
    var index = _a.index, style = _a.style, data = _a.data;
    var width = useWindowSize().width;
    var clientId = useRewards().clientId;
    var desktopBreakpoint = numericBreaks.desktop;
    var items = data.items, selectedCertificates = data.selectedCertificates, onChangeCertificates = data.onChangeCertificates;
    var certificate = items[index];
    var islessThanCustomDesktopSize = width < desktopBreakpoint;
    var containerHeight = islessThanCustomDesktopSize ? 100 : 0;
    var certificateAmount = certificate.certificateAmount, certificateExpiryDate = certificate.certificateExpiryDate, certificateIndex = certificate.certificateIndex;
    return (_jsx("div", __assign({ style: __assign(__assign({}, style), { height: "".concat(containerHeight, "%") }) }, { children: _jsx(CertificateCardContainer, { children: _jsx(Certificate, { certificateIndex: Number(certificateIndex), certificateAmount: certificateAmount, certificateExpiryDate: certificateExpiryDate, isExpiringSoon: isCertificateExpiringSoon(clientId, certificateExpiryDate), isChecked: isCertificateSelected(certificate, selectedCertificates), client: clientId, onChange: function () { return onChangeCertificates(certificate); } }, "certificate-detail-".concat(index)) }) })));
};
export default VirtualizedListRow;
